package app.nestbridge.feature.careteam.presentation

import app.nestbridge.feature.careteam.screen.CreateCareTeamScreen
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.Navigator
import com.slack.circuit.runtime.presenter.Presenter
import com.slack.circuit.runtime.screen.Screen
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
@Origin(CreateCareTeamPresenter::class)
public class CreateCareTeamPresenterFactory(
  private val factory:
      (screen: CreateCareTeamScreen, navigator: Navigator) -> CreateCareTeamPresenter,
) : Presenter.Factory {
  override fun create(
    screen: Screen,
    navigator: Navigator,
    context: CircuitContext,
  ): Presenter<*>? = when (screen) {
    is CreateCareTeamScreen -> factory(screen, navigator)
    else -> null
  }
}
